// extracted by mini-css-extract-plugin
module.exports = {"contCardsProducts":"styles_contCardsProducts__TdjBg","columnRight":"styles_columnRight__2zX1W","contParamsViews":"styles_contParamsViews__DIuA0"};